import React from "react";
import { Button, useWizard } from "@picklebet/ui";
import { useDepositWizard } from "@/features/wallet/components/deposit/hooks/useDepositWizard";
import { useSelectedCard } from "@/features/wallet/components/deposit/hooks/useSelectedCard";
import { constructCurrency } from "common/currency";
import type { DepositMethodStepName } from "@/features/wallet/components/deposit/utils/registry";

export const DebitCardDepositAction = ({ loading }: { loading?: boolean }) => {
  const { amount } = useDepositWizard();
  const { goTo } = useWizard<DepositMethodStepName>();
  const { selectedCard, isLoading: selectedCardLoading } = useSelectedCard();

  if (!selectedCard && !selectedCardLoading) {
    return <Button onClick={() => goTo("debit-card/add")}>Add Card</Button>;
  }

  return (
    <Button
      type="submit"
      disabled={amount === 0 || loading || selectedCardLoading}
      loading={loading || selectedCardLoading}
    >
      Deposit {constructCurrency(amount * 100)}
    </Button>
  );
};
